import { createFileRoute } from "@tanstack/react-router";

import BlogIndexPage from "@/landing/blog/page";
import { buildBlogIndexView, parseBlogIndexSearch } from "@/server-fns/blog/indexView";
import { buildIndexHead } from "@/server-fns/blog/seo";
import { listBlogPostsFn } from "@/server-fns/blog/serverFns";

export const Route = createFileRoute("/blog/")({
    validateSearch: parseBlogIndexSearch,
    loader: async () => {
        const posts = await listBlogPostsFn();
        return { posts };
    },
    head: ({ loaderData, match }) => {
        const posts = loaderData?.posts ?? [];
        return buildIndexHead(buildBlogIndexView(posts, match?.search ?? {}), posts);
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { posts } = Route.useLoaderData();
    const search = Route.useSearch();
    return <BlogIndexPage posts={posts} pillar={search.pillar} page={search.page} />;
}
